import { CardActionState } from './types';

const defaultCardActionProviderState: CardActionState = {
  errorState: {
    freezeCardDataError: undefined,
  },
  onViewCardDetails: () => {},
  onTopUpCard: () => {},
  onFreezeCard: () => {},
  onUnfreezeCard: () => {},
  onChangePIN: () => {},
  onRenewCard: () => {},
  onReportCardAsDestroyed: () => {},
  onReportCardAsStolen: () => {},
  onResetPINRetry: () => {},
  onLimits: () => {},
  onTerminateCard: () => {},
  onActivateCard: () => {},
  onPermanentBlockCard: () => {},
  onResetPinTriesExceeded: () => {},
};

export { defaultCardActionProviderState };
